<template>
  <div class="sel-main-wrapper">
    <i
      class="arrow el-icon-caret-bottom"
      v-if="!yearMonthVisible"
      @click="handleBottomArrow"
    ></i>
    <i
      class="arrow el-icon-caret-top"
      v-if="yearMonthVisible"
      @click="handleTopArrow"
    ></i>
    <div class="selector-wrapper" v-if="yearMonthVisible">
      <div class="flex">
        <div class="common-wrapper">
          <div class="title">年</div>
          <div class="ul" ref="yearUlRef">
            <div
              class="li"
              v-for="item in yearList"
              :key="item"
              @click="handleYearSelect(item)"
            >
              <span :class="{ active: curYear === item }">{{ item }}</span>
            </div>
          </div>
        </div>

        <div class="common-wrapper">
          <div class="title">月</div>
          <div class="ul" ref="monthUlRef">
            <div
              class="li"
              v-for="item in monthList"
              :key="item"
              @click="handleMonthSelect(item)"
            >
              <span
                :class="{
                  active: curMonth === item,
                  // disable: new Date().getMonth() + 1 < item,
                  disable: handleYearDisable(item),
                }"
                >{{ item }}月</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="btn-wrapper">
        <div class="confirm-btn" @click="handleConfirm">确定</div>
      </div>
    </div>
    <div
      class="selector-shadow"
      v-if="yearMonthVisible"
      @click="handleClickShadow"
    ></div>
  </div>
</template>
<script>
export default {
  name: "",
  props: ["CalenderYear", "CalenderMonth"],
  data() {
    return {
      yearMonthVisible: false,
      yearList: [],
      monthList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      curYear: "",
      curMonth: "",
    };
  },
  created() {
    this.handleReset();
  },
  methods: {
    handleReset() {
      let date = new Date();
      // 固定初始年分从当前年的前十年
      let nowYear = date.getFullYear();
      this.yearList = [];
      this.curYear = this.CalenderYear;
      this.curMonth = this.CalenderMonth;
      let startYear = nowYear - 10;
      // 今年之前的所有年份都能选
      for (let i = startYear; i <= nowYear; i++) {
        this.yearList.push(i);
      }
    },
    handleBottomArrow() {
      // console.log("选择年月");
      this.handleReset();
      this.yearMonthVisible = true;
      this.$nextTick(() => {
        const yearUl = this.$refs["yearUlRef"];
        if (yearUl) {
          // 年份 ul 列表自动滚动到底部，未来年份不可选
          yearUl.scrollTo(0, yearUl.scrollHeight);
          yearUl.id = "yearUl";
        }
        const monthUl = this.$refs["monthUlRef"];
        if (monthUl) {
          monthUl.scrollTo(0, (this.curMonth - 2) * 38);
          monthUl.id = "monthUl";
        }
      });
    },
    handleTopArrow() {
      this.yearMonthVisible = false;
    },
    handleYearSelect(year) {
      this.curYear = year;
    },
    // 处理月份置灰
    handleYearDisable(month) {
      let disable;
      // 选中年份小于当前年份，放行
      if (this.curYear < new Date().getFullYear()) {
        disable = false;
        return disable;
      }
      // 选中年份等于当前年份，则大于当前月份置灰
      return new Date().getMonth() + 1 < month;
    },
    handleMonthSelect(month) {
      // 选中年份小于当前年份，放行
      if (this.curYear < new Date().getFullYear()) {
        this.curMonth = month;
        return;
        // 选择的月份大于当前月，阻止
      } else if (new Date().getMonth() + 1 < month) return;
      this.curMonth = month;
    },
    handleConfirm() {
      this.$emit("confirm", {
        curYear: this.curYear,
        curMonth: this.curMonth,
      });
      this.yearMonthVisible = false;
    },
    // 蒙层
    handleClickShadow() {
      this.yearMonthVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.sel-main-wrapper {
  position: relative;
  .selector-wrapper {
    position: absolute;
    top: 23px;
    left: -75px;
    border: 1px solid #e7e8ea;
    background: white;
    padding: 0 30px;
    z-index: 1011;
    .common-wrapper {
      flex: 1;
      &:nth-child(1) {
        margin-right: 20px;
      }
      .title {
        margin: 12px 0;
      }
      .ul {
        height: 220px;
        overflow: hidden;
        overflow-y: auto;
        &::-webkit-scrollbar {
          width: 4px;
        }
        &::-webkit-scrollbar-track {
          width: 4px;
          background: none;
        }
        &::-webkit-scrollbar-thumb {
          width: 4px;
          background: #d8d8d8;
        }
        &::-webkit-scrollbar-button {
        }

        .li {
          padding: 10px 0px;
          cursor: pointer;
          width: 40px;
          .active {
            color: #07d1aa;
            border-top: 1px solid #e7e8ea;
            border-bottom: 1px solid #e7e8ea;
            padding: 10px 5px;
          }
          .disable {
            color: #ddd;
            border: none;
            cursor: not-allowed;
          }
        }
      }
    }
    .btn-wrapper {
      margin: 15px 0;
      .confirm-btn {
        background: #07d1aa;
        color: white;
        border-radius: 5px;
        height: 25px;
        line-height: 25px;
        width: 70px;
        margin: 0 auto;
      }
    }
  }
  .selector-shadow {
    position: fixed;
    z-index: 1010;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
}
.arrow {
  padding: 0 2px;
  cursor: pointer;
  color: #07d1aa;
  font-size: 16px;
  &.disable {
    cursor: not-allowed;
    color: #ddd;
  }
}
.flex {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
</style>
